import { useState } from 'react';
import { Alert, Box, Snackbar, Typography } from '@mui/material';

const PREVIEW_NOTICE = 'This is a preview of what your customers will experience after you publish.';

const PreviewPane = ({ title, children, contentSx = {}, sx = {} }) => {
  const [isNoticeOpen, setIsNoticeOpen] = useState(false);

  const handlePreviewClick = () => {
    setIsNoticeOpen(true);
  };

  const handleNoticeClose = (_event, reason) => {
    if (reason === 'clickaway') return;
    setIsNoticeOpen(false);
  };

  return (
    <>
      <Box
        aria-label={title}
        onClickCapture={handlePreviewClick}
        sx={{
          flex: { xs: '0 0 auto', md: 1 },
          order: { xs: 1, md: 2 },
          minWidth: 0,
          backgroundColor: '#f5f5f5',
          height: { xs: 'auto', md: '100%' },
          cursor: 'default',
          mt: { xs: 3, md: 0 },
          ...sx,
        }}
      >
        <Box
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 1,
            px: { xs: 1.5, md: 2 },
            height: 40,
            backgroundColor: '#ffffff',
            borderBottom: '1px solid #e0e0e0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            component="h2"
            sx={{
              color: 'text.primary',
              fontSize: { xs: '0.9rem', md: '1rem' },
              fontWeight: 600,
              lineHeight: 1.25,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              whiteSpace: 'nowrap',
            }}
          >
            {title}
          </Typography>
        </Box>

        <Box
          sx={{
            width: '100%',
            pt: { xs: 0, md: '1rem' },
            ...contentSx,
          }}
        >
          {children}
        </Box>
      </Box>

      <Snackbar
        open={isNoticeOpen}
        autoHideDuration={3000}
        onClose={handleNoticeClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="info" variant="filled" onClose={handleNoticeClose}>
          {PREVIEW_NOTICE}
        </Alert>
      </Snackbar>
    </>
  );
};

export default PreviewPane;
